/* eslint-disable */
import { Typography } from 'antd';
import React, { FC, useEffect, useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';
import { usePageTitle } from '~/context/PageTitleContext';
import features from '~/constants/features';
import { useProceedStep, useSelectStep } from '~/controllers/wizard';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import LeftLayout from '~/layouts/LeftLayout';
import WizardContent from '~/layouts/WizardContent';
import WizardContinueButton from '~/layouts/WizardContinueButton';
import { isAgent } from '~/utils/getDecodedJwt';
import paths from '~/pages/paths';
import { Stage } from '~/types/Application';
import { SuccessfulOnboardingImg } from '~/img';
import { proceedReviewSuccess } from '~/api/review';
import CompletionContainer from '~/pages/ksa/completion/components/CompletionContainer';

const ReviewSuccess: FC<void> = () => {
  const { t } = useTranslation('ksaCompletion');
  const { setPageTitle } = usePageTitle();

  useLayoutEffect(() => {
    setPageTitle(t('Application Approved'));
    return () => setPageTitle('');
  }, []);
  const history = useHistory();

  const selectStepMutation = useSelectStep();
  const proceed = useProceedStep(proceedReviewSuccess);
  useLayoutEffect(() => {
    proceed.mutateAsync().catch((e) => {
      console.error(`failed to submit; error:`, e);
    });
  }, []);

  useEffect(() => {
    if (isAgent()) {
      void selectStepMutation
        .mutateAsync({
          stageKey: Stage.ksaReview,
          stepKey: 'review.completeReview',
        })
        .then(() => {
          history.push(`${paths.ksa.review}/completeReview`);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClick = () => {
    proceed.mutateAsync().catch((e) => {
      console.error(`failed to submit; error:`, e);
    });
  };

  return isAgent() ? (
    <div />
  ) : (
    <WizardContent
      left={
        <LeftLayout>
          <BottomLeftActions contactUsUrl={features.contactUsLinkHardDecline} />
        </LeftLayout>
      }
      content={
        <CompletionContainer>
          <Typography.Title>{t('Application approved!')}</Typography.Title>
          <Typography.Paragraph className="Completion-Paragraph">
            <p>{t('Welcome to the Network family.')}</p>
            <p>
              {t(
                'We will soon be sending you our welcome kit which will explain the next steps to enable you to start taking payments.'
              )}
            </p>
            <p>
              <Trans
                t={t}
                i18nKey="In the meantime, if you wish to speak to us, please <1>contact us</1>."
              >
                {'In the meantime, if you wish to speak to us, please '}
                <a href={features.contactUsLink} target="__blank">
                  contact us
                </a>
                .
              </Trans>
            </p>
          </Typography.Paragraph>
          <SuccessfulOnboardingImg className="Completion-Img" />
        </CompletionContainer>
      }
      right={
        <WizardContinueButton
          id="payment_continueButton"
          onClick={onClick}
          loading={proceed.isLoading}
        >
          {t('Submit', { ns: 'common' })}
        </WizardContinueButton>
      }
    />
  );
};

export default ReviewSuccess;
